import { render, staticRenderFns } from "./VideoSurveillance.vue?vue&type=template&id=3695de8e&scoped=true&"
import script from "./VideoSurveillance.vue?vue&type=script&lang=js&"
export * from "./VideoSurveillance.vue?vue&type=script&lang=js&"
import style0 from "./VideoSurveillance.vue?vue&type=style&index=0&id=3695de8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695de8e",
  null
  
)

export default component.exports